import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_user_view",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-13 text-center\"><h1 class=\"mb-3\">View User Details</h1></div><div class=\"row mb-7\"><label class=\"col-lg-5 fw-bold fs-6\">University:</label><div class=\"col-lg-7 fv-row\"><span class=\"fw-bold fs-6\">Gannon University</span></div></div>", 2)
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Full Name:", -1)
const _hoisted_12 = { class: "col-lg-7 fv-row" }
const _hoisted_13 = { class: "fw-bold fs-6" }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Email:", -1)
const _hoisted_16 = { class: "col-lg-7 fv-row" }
const _hoisted_17 = { class: "fw-bold fs-6" }
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Phone:", -1)
const _hoisted_20 = { class: "col-lg-7 fv-row" }
const _hoisted_21 = { class: "fw-bold fs-6" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "User Type:", -1)
const _hoisted_24 = { class: "col-lg-7 fv-row" }
const _hoisted_25 = { class: "fw-bold fs-6 text-uppercase" }
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Registered Date:", -1)
const _hoisted_28 = { class: "col-lg-7 fv-row" }
const _hoisted_29 = { class: "fw-bold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currentUserEdit.title) + " " + _toDisplayString(_ctx.currentUserEdit.firstname) + " " + _toDisplayString(_ctx.currentUserEdit.middlename) + " " + _toDisplayString(_ctx.currentUserEdit.lastname), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentUserEdit.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentUserEdit.phone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.currentUserEdit.role), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.moment(_ctx.currentUserEdit.createdDate)), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}